<template>
    <div>
        <el-page-header class="page-header" @back="goBack" content="订单详情">
        </el-page-header>
        <!-- 订单状态信息 -->
        <div class="order-status" v-if="detailData.order_sn">
            <div class="status-text">
                <span class="order-sn">订单编号：{{ detailData.order_sn }}</span>
            </div>
            <div class="payment-info">
                <div>
                    <div class="payment-status">{{ detailData.status_txt }}</div>
                    <div class="payment-tip" v-if="detailData.status == '1'">用户已付款，等待发货中</div>
                    <div class="payment-tip" v-if="detailData.status == '2'">快递已发货，等待对方确认收货</div>
                </div>
                <div>
                    <el-button type="primary" size="small" v-if="detailData.status == '1'"
                        @click.stop="openShipmentDialog">确认发货</el-button>
                    <el-button type="primary" size="small" v-if="detailData.status == '2'"
                        @click="logisticsVisible = true">查看物流</el-button>
                </div>
            </div>
        </div>
        <!-- 收货人和订单信息 -->
        <div class="info-section" v-if="detailData.order_sn">
            <div class="info-left">
                <div class="section-title">收货人信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">收货人：</span>
                        <span class="info-value">{{ detailData.addressInfo.receiver_name }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">联系电话：</span>
                        <span class="info-value">{{ detailData.addressInfo.receiver_mobile }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">收货地址：</span>
                        <span class="info-value">{{ detailData.addressInfo.province }}{{ detailData.addressInfo.city
                        }}{{ detailData.addressInfo.district }}{{ detailData.addressInfo.receiver_address }}</span>
                    </div>
                </div>
            </div>
            <div class="info-right">
                <div class="section-title">订单信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">订单备注：</span>
                        <span class="info-value">{{ detailData.remark || '无' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">订单编号：</span>
                        <span class="info-value">{{ detailData.order_sn }} <span class="copy-btn">复制</span></span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">下单时间：</span>
                        <span class="info-value">{{ detailData.create_time }}</span>
                    </div>
                </div>
            </div>
            <div class="info-left" v-if="detailData.status >= '1'">
                <div class="section-title">付款信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">付款方式：</span>
                        <span class="info-value">{{ detailData.pay_type }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">支付时间：</span>
                        <span class="info-value">{{ detailData.pay_time }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 商品列表 -->
        <el-table :data="detailData.goods" style="width: 100%" :border="true" :span-method="spanMethod">
            <el-table-column label="商品名称" width="400" align="center">
                <template slot-scope="scope">
                    <div class="goods-info">
                        <img :src="scope.row.goods_thumb" alt="" class="goods-image" />
                        <div class="goods-details">
                            <div class="goods-name">{{ scope.row.goods_name }}</div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div class="goods-spec">{{ scope.row.sku_name }}</div>
                                <div class="goods-price">
                                    <span>¥{{ scope.row.shop_price }}</span>
                                    <!-- <span>/棵</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="num" label="数量" align="center" />
            <el-table-column label="金额" align="center">
                <template slot-scope="scope">
                    <span>{{ detailData.payable_money }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                    <span>{{ detailData.status_txt }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="money_box">
            <div class="money-item">商品金额：¥{{ detailData.order_money }}</div>
            <div class="money-item">优惠券：¥{{ detailData.coupon_money }}</div>
            <div class="money-item">运费：¥{{ detailData.express_price }}</div>
            <div class="money-item">
                <span>{{ detailData.status > 0 ? '实付款' : '应付款' }}：</span>
                <span style="color: #F02325;font-weight: bold;">¥</span>
                <span class="payable-txt">{{ detailData.payable_money }}</span>
            </div>
        </div>
        <!-- 发货弹窗 -->
        <el-dialog title="发货" :visible.sync="shipmentVisible" width="40%" center>
            <div class="dialog-content">
                <div class="form-item">
                    <label class="">快递公司：</label>
                    <el-select v-model="shipmentInfo.express_company_id" placeholder="请选择快递公司">
                        <el-option v-for="(item, index) in companyList" :key="index" :label="item.name"
                            :value="item.aid" />
                    </el-select>
                </div>
                <div class="form-item">
                    <label>快递单号：</label>
                    <el-input v-model="shipmentInfo.express_no" placeholder="请输入快递单号" />
                </div>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" @click="confirmShipment">确定发货</el-button>
            </div>
        </el-dialog>
        <!-- 物流信息 -->
        <el-dialog title="物流信息" :visible.sync="logisticsVisible" width="60%" center>
            <ViewLogistics v-if="detailData.aid" :orderId="detailData.aid" :isAfter="false" />
        </el-dialog>
    </div>
</template>

<script>
import ViewLogistics from '@/components/ViewLogistics.vue'
export default {
    name: 'ShopOrderDetail',
    components: {
        ViewLogistics,
    },
    props: {
        order_sn: {
            type: String,
            default: ''
        },
        partner_id: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            logisticsVisible: false, // 物流弹窗是否可见
            companyList: [], // 物流公司列表
            shipmentVisible: false, // 发货弹窗是否可见
            shipmentInfo: {
                express_company: '', // 快递公司
                express_company_id: '', // 快递公司ID
                express_no: '' // 快递单号
            },
            detailData: {
                aid: '',
                goods: [],
            },  // 详情列表
        }
    },
    mounted() {
        this.getOrderDetail();
    },
    methods: {
        goBack() {
            this.$emit('goToComponent', 'ShopOrderList');
        },
        openShipmentDialog() {
            this.$api.getLogisticsCompany().then(res => {
                this.companyList = res;
            }).catch(err => {
                this.$message.error(err);
            })
            this.shipmentVisible = true;
        },
        // 确认发货
        confirmShipment() {
            if (!this.shipmentInfo.express_company_id) {
                this.$message.warning('请选择快递公司');
                return;
            }
            if (!this.shipmentInfo.express_no) {
                this.$message.warning('请输入快递单号');
                return;
            }
            this.$confirm('确定要发货吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$dapi.confirmShipment({
                    order_id: this.detailData.aid,
                    express_company_id: this.shipmentInfo.express_company_id,
                    express_no: this.shipmentInfo.express_no
                }).then(res => {
                    this.$message.success('发货成功');
                    this.shipmentVisible = false;
                    this.getOrderDetail();
                }).catch(err => {
                    this.$message.error(err);
                });
            }).catch(() => {
                // this.$message.info('已取消发货');
            });
        },
        // 单元格合并方法
        spanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 2 || columnIndex === 3) {
                if (rowIndex === 0) {
                    return {
                        rowspan: this.detailData.goods.length,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        getOrderDetail() {
            this.$api.getShopOrderDetail({
                order_sn: this.order_sn,
                partner_id: this.partner_id,
                order_type: '3'
            }).then(res => {
                this.detailData = res;
            }).catch(err => {
                this.$message.error(err);
            });
        }
    }
}
</script>

<style scoped>
.order-detail {
    padding: 20px;
    background-color: #fff;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 订单状态区域 */
.order-status-section {
    margin-bottom: 20px;
}

.order-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
}

.order-status {
    text-align: left;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 15px;
}

.status-text {
    margin-bottom: 10px;
}

.status-label {
    font-size: 14px;
    color: #333;
    margin-right: 20px;
}

.order-sn {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.payment-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: end;
}

.payment-status {
    font-weight: bold;
    font-size: 16px;
    color: #286CED;
}

.payment-tip {
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
}

.payment-time {
    font-size: 14px;
    color: #666;
}

.time-value {
    color: #e74c3c;
    font-weight: 500;
}

.order-tip {
    font-size: 12px;
    color: #999;
    line-height: 1.5;
}

/* 信息区域 */
.info-section {
    display: flex;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
}

.info-left,
.info-right {
    width: calc(50% - 10px);
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    /* padding: 15px; */
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    background: #FAFAFA;
    color: #333;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    padding: 10px 15px;
}

.section-title::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 16px;
    background-color: #286CED;
    margin-right: 8px;

}

.info-content {
    font-size: 14px;
    text-align: left;
    padding: 0px 15px 0px 15px;
}

.info-item {
    margin-bottom: 10px;
}

.info-label {
    color: #666;
    margin-right: 10px;
}

.info-value {
    color: #333;
}

.copy-btn {
    color: #286CED;
    cursor: pointer;
    margin-left: 10px;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.goods-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
    margin-right: 15px;
}

.goods-details {
    min-height: 80px;
    flex: 1;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.goods-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    font-size: 12px;
    color: #999;
}

.money_box {
    display: flex;
    flex-direction: column;
    align-items: end;
    margin-top: 20px;
}

.money-item {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-bottom: 10px;
}

.payable-txt {
    font-weight: bold;
    font-size: 20px;
    color: #F02325;
    margin-left: 2px;
}

.dialog-content {
    width: 100%;
}

.form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    label {
        font-weight: 400;
        font-size: 14px;
        color: #221E1F;
        margin-bottom: 16px;
    }
}

.dialog-footer {
    display: flex;
    justify-content: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .info-section {
        flex-direction: column;
    }

    .product-header,
    .product-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .product-info,
    .product-quantity,
    .product-buyer,
    .product-amount,
    .product-status,
    .product-operation {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
    }
}
</style>